export enum ContactWaiverStatus {
    UNKNOWN,
    NEEDSSIGNING,
    ALREADYSIGNED,
    BUSINESSDOESNOTREQUIRESIGNINGWAIVERS
}